import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import Global from '../../../store/global-selectors';
import DataDrivenLogoColumn from '../data-driven-logo-column';

const StoreColumn = ({ storeGuid = '' }) => {
  let isEmpty = true;
  let dataDrivenLogoProps = {};
  let message = '';

  const sellerStores = useSelector(Global.selectSellergetStoreInformations);
  const sellerStore = sellerStores[storeGuid];
  if (sellerStore) {
    const { name, marketplaceId } = sellerStore;
    isEmpty = false;
    dataDrivenLogoProps = { marketplaceId };
    message = name;
  }

  return <DataDrivenLogoColumn dataDrivenLogoProps={dataDrivenLogoProps} isEmpty={isEmpty} message={message} />;
};

StoreColumn.propTypes = {
  storeGuid: PropTypes.string,
};

export default StoreColumn;
